export default {
	// SOLUTIONS
  'ergonomics_and_mobilization': {
    description: `
      <h3>Mobi-Rail®</h3> Enhances patient mobilization by reducing physical effort for both patients and caregivers, functions as a physiotherapeutic tool, and provides convenient accessory placement for urine or drainage bags and crutches.<br><br>
      <h3>Variety of Control Elements</h3> Ensures ease of use for both patients and caregivers, improving accessibility and operation.<br><br>
      <h3>SoftBrakes®</h3> Ensure effortless pedal activation offering a 56-93% force reduction compared to the maximum acceptable level.<br><br>
    `,
    images: [
      'essenza200/ergonomics_and_mobilization.jpg'
    ]
  },
  'safety_and_comfort': {
    description: `
      <h3>3 Siderails Concept</h3> Protects individuals with reduced mobility from falling during sleep.<br><br>
      <h3>Ergoframe®</h3> Increases patient comfort and reduces the peak pressure in pelvic area by 16%.<br><br>
      <h3>Wide range of mattresses</h3> Provides high patient comfort and prevents pressure injuries.<br><br>
    `,
    images: [
      'essenza200/safety_and_comfort.jpg'
    ]
  },
  'effectiveness_and_wellbeing': {
    description: `
      <h3>SafeSense 3</h3> Helps to save time by giving a remote overview of the patient.<br><br>
      <h3>SmartTracking</h3> Facilitates work of caregivers by tracking hospital assets or patients.<br><br>
      <h3>DesignInk®</h3> Reduces the fear and anxiety of patients, but also improves working environment for medical staff.<br><br>
    `,
    images: [
      'essenza200/effectiveness_and_wellbeing.jpg'
    ]
  },

	// KEY FEATURES
  'ergonomics_mobilization': {
    subExplanations: [
      'mobirail',
      'mobigrips',
      'softbrakes'
    ]
  },
  'comfort': {
    subExplanations: [
      'siderails_concept',
      'ergoframe'
    ]
  },
  'variety_of_controls': {
    subExplanations: [
      'caregiver_controls',
      'patient_controls'
    ],
    camera: {
      orbit: '20deg 77.96deg 40.8m',
      target: '-49m 96m 50m'
    }
  },
  'variety_of_siderails': {
    subExplanations: [
      'plastic_siderails',
      'metal_siderails'
    ],
    camera: {
      orbit: '0deg 77.96deg 60m',
      target: '0m 92m 50m'
    }
  },

  // SUB-EXPLANATIONS
  'mobirail': {
    heading: 'Mobi-Rail®',
    description: 'Enhances patient mobilization by reducing physical effort for both patients and caregivers, functions as a physiotherapeutic tool, and provides convenient accessory placement for urine or drainage bags and crutches.',
    images: [
      'essenza200/mobirail.jpg'
    ],
    camera: {
      orbit: '20deg 70deg 40m',
      target: '90m 95m 50m'
    }
  },
  'mobigrips': {
    heading: 'Mobi-Grips',
    description: 'Ergonomic grips in the siderails support the patient during the standing up procedure.',
    images: [
      'essenza200/mobigrips.jpg'
    ],
    camera: {
      orbit: '20deg 60deg 60m',
      target: '-40m 106m 49m'
    }
  },
  'softbrakes': {
    heading: 'SoftBrakes®',
    description: 'SoftBrakes ensure effortless pedal activation offering a 56-93% force reduction compared to the maximum acceptable level.',
    images: [
      'essenza200/softbrakes.jpg'
    ],
    camera: {
      orbit: '20deg 70deg 20m',
      target: '80m 44m 41m'
    }
  },
  'siderails_concept': {
    heading: '3 Siderails Concept',
    description: '3 Siderails Concept protects individuals with reduced mobility from falling during sleep.',
    images: [
      'essenza200/siderails_concept.jpg'
    ]
  },
  'ergoframe': {
    heading: 'Ergoframe®',
    description: 'Unique frame design increases patient comfort and reduces peak pressure in the pelvic area by 16%.',
    images: [
      'essenza200/ergoframe.jpg'
    ]
  },
  'caregiver_controls': {
    heading: 'Caregiver Empowering Controls',
    description: 'Standardized designs simplify the training process, enabling staff to become proficient with equipment quickly.',
    images: [
      'essenza200/caregiver_controls.jpg'
    ],
    camera: {
      orbit: '20deg 77.96deg 40.8m',
      target: '-49m 96m 50m'
    }
  },
  'patient_controls': {
    heading: 'Patient Empowering Controls',
    description: 'Patient can easily reach bed controls while sitting or lying.',
    images: [
      'essenza200/patient_controls.jpg'
    ],
    camera: {
      orbit: '20deg 70deg 20m',
      target: '-72m 112m -46m'
    }
  },
  'plastic_siderails': {
    heading: 'Plastic Siderails',
    description: '',
    images: [
      'essenza200/plastic_siderails.jpg'
    ]
  },
  'metal_siderails': {
    heading: 'Metal Siderails',
    description: '',
    images: [
      'essenza200/metal_siderails.jpg'
    ]
  }
}
